import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css'

const DEFAULT_ROW = 16
class PrintReportStockFixingCar extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('landscape');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        if (this.props.isRange=='false'&&this.props.year!=undefined&&this.props.month!=undefined&&this.props.day!=undefined&&this.props.searchBy!=undefined&&this.props.query!=undefined) {
            ReportStore.loadReportStockFixingCar(this.props.year,this.props.month,this.props.day,this.props.searchBy,this.props.query,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{

            })   
        } else if (this.props.isRange=='true'&&this.props.startDate!=undefined&&this.props.endDate!=undefined&&this.props.searchBy!=undefined&&this.props.query!=undefined) {
            ReportStore.loadReportStockFixingCarRange(this.props.startDate,this.props.endDate,this.props.searchBy,this.props.query,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{
                
            })
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

    getSummary(field) {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
        }) 
        return total
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderRowData(data,indexs) {
        if (data.length===0) {
          return(<tr><td colSpan={13}>ไม่พบข้อมูล</td></tr>)
        } else {
            return(
                data.map((item,index)=>{
                    return(
                        <tr key={index}>
                            <td className='text-center'>{item.work_date}</td>
                            <td className='text-center'>{item.work_no}</td>
                            <td className='text-center'>{item.customer_name}</td>
                            <td className='text-center'>{item.car_registration_no}</td>
                            <td className='text-center'>{item.car_no}</td>
                            <td className='text-center'>{item.work_for}</td>
                            <td className='text-left'>{item.description}</td>
                            <td className='text-center'>{item.quantity}</td>
                            <td className='text-center'>{item.unit}</td>
                            <td className='text-right'>{this.getNumberFormat(item.cost)}</td>
                            <td className='text-right'>{this.getNumberFormat(item.price)}</td>
                            <td className='text-center'>{item.fixed_by}</td>
                            <td className='text-center'>{item.request_by}</td>
                        </tr>
                    )
                })
            )
        }
    }

    renderTable(item,index,length) {
        return(
            <table className='table table-print-report-analysis'>
                <tbody>
                    <tr>
                        <td className='text-center' style={{width:'110px'}}>วันที่ใบงาน</td>
                        <td className='text-center' style={{width:'120px'}}>เลขที่ใบงาน</td>
                        <td className='text-center' style={{width:'100px'}}>ลูกค้า</td>
                        <td className='text-center' style={{width:'100px'}}>ทะเบียนรถ</td>
                        <td className='text-center' style={{width:'80px'}}>เบอร์รถ</td>
                        <td className='text-center' style={{width:'100px'}}>ประเภท</td>
                        <td className='text-center' style={{width:'150px'}}>รายการ</td>
                        <td className='text-center' style={{width:'90px'}}>จำนวน</td>
                        <td className='text-center' style={{width:'90px'}}>หน่วย</td>
                        <td className='text-center' style={{width:'100px'}}>ต้นทุน</td>
                        <td className='text-center' style={{width:'100px'}}>ราคา</td>
                        <td className='text-center' style={{width:'110px'}}>ซ่อมโดย</td>
                        <td className='text-center' style={{width:'110px'}}>เบิกโดย</td>
                    </tr>
                    {this.renderRowData(item,index)}
                    {index===length-1?
                    <tr>
                        <td colSpan={9}></td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('cost'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('price'))}</td>
                        <td colSpan={2}></td>
                    </tr>
                    :''}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                    size='landscape'
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                    size='landscape'
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportStockFixingCar.defaultProps = {
    title: 'ตารางรายงานซ่อมรถเบิกคลัง',  
    mode: '',
    workNo: ''
  }
  export default PrintReportStockFixingCar;


// WEBPACK FOOTER //
// ./src/view/print/stock/PrintReportStockFixingCar.js